import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/LegalPages.css';

const CGV = () => {
  const { t } = useTranslation();

  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="back-link">
          ← {t('legal.backHome') || 'Retour à l\'accueil'}
        </Link>

        <h1 className="legal-title">
          {t('legal.cgv.title') || 'Conditions Générales de Vente'}
        </h1>

        <div className="legal-content">
          {/* Introduction */}
          <section className="legal-section">
            <p className="legal-intro">
              Les présentes Conditions Générales de Vente (CGV) régissent les relations contractuelles entre DreamDev, développeur web et mobile indépendant (ci-après "le Prestataire") et toute personne physique ou morale (ci-après "le Client") souhaitant bénéficier des services proposés.
            </p>
          </section>

          {/* Article 1 - Objet */}
          <section className="legal-section">
            <h2>Article 1 - Objet</h2>
            <p>
              Les présentes CGV ont pour objet de définir les conditions dans lesquelles le Prestataire fournit au Client les services suivants :
            </p>
            <ul>
              <li>Développement de sites web (vitrines, e-commerce, applications web)</li>
              <li>Développement d'applications mobiles (iOS, Android, React Native)</li>
              <li>Refonte et maintenance de sites existants</li>
              <li>Optimisation et référencement (SEO)</li>
              <li>Conseil et accompagnement technique</li>
            </ul>
          </section>

          {/* Article 2 - Acceptation */}
          <section className="legal-section">
            <h2>Article 2 - Acceptation des CGV</h2>
            <p>
              Toute commande implique l'acceptation sans réserve des présentes CGV. Le Client reconnaît avoir pris connaissance des présentes conditions et les avoir acceptées avant la signature du devis ou le paiement de l'acompte.
            </p>
            <p>
              Ces conditions prévalent sur tout autre document du Client, notamment sur toutes conditions générales d'achat, sauf accord préalable, exprès et écrit du Prestataire.
            </p>
          </section>

          {/* Article 3 - Devis */}
          <section className="legal-section">
            <h2>Article 3 - Devis et commande</h2>
            <p>
              <strong>3.1 Établissement du devis</strong><br />
              Suite à la demande du Client, un devis détaillé est établi gratuitement. Ce devis comprend :
            </p>
            <ul>
              <li>La description détaillée des prestations</li>
              <li>Le prix total en euros (€) TTC</li>
              <li>Les délais de réalisation</li>
              <li>Les conditions de paiement</li>
              <li>La durée de validité du devis (30 jours)</li>
            </ul>
            <p>
              <strong>3.2 Validation de la commande</strong><br />
              La commande est confirmée par la signature du devis et le versement de l'acompte. Toute modification demandée par le Client après validation du devis fera l'objet d'un avenant et pourra entraîner un surcoût et/ou un délai supplémentaire.
            </p>
          </section>

          {/* Article 4 - Prix */}
          <section className="legal-section">
            <h2>Article 4 - Prix</h2>
            <p>
              <strong>4.1 Tarification</strong><br />
              Les prix sont indiqués en euros (€) et s'entendent toutes taxes comprises (TTC). Le Prestataire étant en micro-entreprise, la TVA n'est pas applicable (Article 293B du CGI).
            </p>
            <p>
              <strong>4.2 Révision des prix</strong><br />
              Les prix convenus dans le devis sont fermes et non révisables pendant la durée d'exécution du projet, sauf en cas de demande de modifications substantielles du Client.
            </p>
            <p>
              <strong>4.3 Frais annexes</strong><br />
              Les frais suivants ne sont pas inclus sauf mention contraire dans le devis :
            </p>
            <ul>
              <li>Noms de domaine</li>
              <li>Hébergement web</li>
              <li>Licences logicielles tierces</li>
              <li>Photos et illustrations premium</li>
              <li>Services de référencement payant (Google Ads, etc.)</li>
            </ul>
          </section>

       {/* Article 5 - Paiement */}
        <section className="legal-section">
        <h2>Article 5 - Modalités de paiement</h2>

        <p>
            <strong>5.1 Paiement de la prestation</strong><br />
            Le paiement de la prestation s’effectue en une seule fois, avant le début de toute réalisation. 
            Aucun acompte, paiement intermédiaire ou règlement échelonné n’est proposé.
            La prestation ne commence qu’à réception du paiement complet.
        </p>

        <p>
            <strong>5.2 Moyens de paiement</strong><br />
            Le paiement s’effectue exclusivement via Stripe directement sur le site du Prestataire.
            Aucun autre moyen de paiement n’est accepté.
        </p>

        <p>
            <strong>5.3 Conditions</strong><br />
            Aucun retard de paiement n’est possible, le règlement intégral étant effectué avant le début de la prestation.
        </p>
        </section>


          {/* Article 6 - Délais */}
          <section className="legal-section">
            <h2>Article 6 - Délais de réalisation</h2>
            <p>
              <strong>6.1 Délais indicatifs</strong><br />
              Les délais de réalisation indiqués dans le devis sont donnés à titre indicatif et courent à compter de la réception de l'acompte et de tous les éléments nécessaires à la réalisation du projet (textes, images, accès, etc.).
            </p>
            <p>
              <strong>6.2 Retards</strong><br />
              Le Prestataire s'engage à informer le Client de tout retard prévisible. Les retards ne pourront donner lieu à des pénalités ou à l'annulation de la commande, sauf en cas de retard supérieur à 30 jours après le délai initialement prévu.
            </p>
            <p>
              <strong>6.3 Responsabilité du Client</strong><br />
              Les délais sont suspendus en cas de retard ou d'absence de validation des livrables par le Client, ou en cas de non-fourniture des éléments nécessaires.
            </p>
          </section>

          {/* Article 7 - Obligations */}
          <section className="legal-section">
            <h2>Article 7 - Obligations des parties</h2>
            <p>
              <strong>7.1 Obligations du Prestataire</strong><br />
              Le Prestataire s'engage à :
            </p>
            <ul>
              <li>Mettre en œuvre tous les moyens nécessaires à la bonne exécution du projet</li>
              <li>Respecter les délais convenus dans la mesure du possible</li>
              <li>Livrer un travail conforme aux spécifications du devis</li>
              <li>Assurer la confidentialité des informations transmises</li>
              <li>Fournir un support technique pendant 30 jours après livraison</li>
            </ul>
            <p>
              <strong>7.2 Obligations du Client</strong><br />
              Le Client s'engage à :
            </p>
            <ul>
              <li>Fournir tous les éléments nécessaires à la réalisation du projet</li>
              <li>Répondre aux demandes de validation dans un délai raisonnable (5 jours ouvrés maximum)</li>
              <li>Respecter les échéances de paiement</li>
              <li>Ne pas utiliser les livrables avant paiement intégral</li>
              <li>Garantir qu'il dispose des droits sur tous les contenus fournis</li>
            </ul>
          </section>

          {/* Article 8 - Validation */}
          <section className="legal-section">
            <h2>Article 8 - Validation et modifications</h2>
            <p>
              <strong>8.1 Phases de validation</strong><br />
              Le projet fait l'objet de validations successives à chaque étape importante :
            </p>
            <ul>
              <li>Validation de la maquette/design</li>
              <li>Validation du développement (version beta)</li>
              <li>Validation finale avant mise en ligne</li>
            </ul>
            <p>
              <strong>8.2 Modifications incluses</strong><br />
              Le devis inclut généralement 2 rounds de révisions mineures par phase. Toute demande de modification substantielle ou au-delà de ce nombre fera l'objet d'une facturation supplémentaire.
            </p>
            <p>
              <strong>8.3 Validation tacite</strong><br />
              L'absence de retour du Client dans un délai de 7 jours ouvrés après livraison d'une phase vaudra acceptation tacite de celle-ci.
            </p>
          </section>

          {/* Article 9 - Livraison */}
          <section className="legal-section">
            <h2>Article 9 - Livraison</h2>
            <p>
              <strong>9.1 Modalités de livraison</strong><br />
              La livraison s'effectue par transmission électronique (email, serveur FTP, GitHub, etc.) ou par mise en ligne directe sur l'hébergement du Client.
            </p>
            <p>
              <strong>9.2 Éléments livrés</strong><br />
              Sauf mention contraire dans le devis, sont livrés :
            </p>
            <ul>
              <li>Les fichiers sources du projet</li>
              <li>Les fichiers de production optimisés</li>
              <li>Une documentation technique basique</li>
              <li>Les accès administrateur si applicable</li>
            </ul>
            <p>
              <strong>9.3 Réception</strong><br />
              Le Client dispose d'un délai de 7 jours à compter de la livraison pour formuler des réserves. Passé ce délai, la prestation est considérée comme acceptée.
            </p>
          </section>

          {/* Article 10 - Propriété intellectuelle */}
          <section className="legal-section">
            <h2>Article 10 - Propriété intellectuelle</h2>
            <p>
              <strong>10.1 Transfert de propriété</strong><br />
              Le Client devient propriétaire des créations réalisées spécifiquement pour lui, sous réserve du paiement intégral du prix convenu. Le transfert de propriété s'effectue au paiement du solde.
            </p>
            <p>
              <strong>10.2 Droit de réutilisation</strong><br />
              Le Prestataire se réserve le droit de présenter le projet dans son portfolio professionnel, sauf demande contraire écrite du Client.
            </p>
            <p>
              <strong>10.3 Code source et frameworks</strong><br />
              Les frameworks, bibliothèques et composants open-source utilisés restent la propriété de leurs auteurs respectifs et sont soumis à leurs licences propres.
            </p>
          </section>

          {/* Article 11 - Garanties */}
          <section className="legal-section">
            <h2>Article 11 - Garanties et support</h2>
            <p>
              <strong>11.1 Garantie de bon fonctionnement</strong><br />
              Le Prestataire garantit le bon fonctionnement du site/application pendant 30 jours après livraison, dans les conditions normales d'utilisation et sur les navigateurs/appareils spécifiés dans le devis.
            </p>
            <p>
              <strong>11.2 Support technique</strong><br />
              Un support technique gratuit est assuré pendant 30 jours après livraison pour :
            </p>
            <ul>
              <li>Correction des bugs liés au développement initial</li>
              <li>Assistance à la prise en main</li>
              <li>Questions techniques basiques</li>
            </ul>
            <p>
              <strong>11.3 Maintenance</strong><br />
              La maintenance, les mises à jour et évolutions après la période de garantie font l'objet d'un contrat séparé ou d'une facturation à l'acte.
            </p>
          </section>

          {/* Article 12 - Responsabilités */}
          <section className="legal-section">
            <h2>Article 12 - Limitation de responsabilité</h2>
            <p>
              <strong>12.1 Responsabilité du Prestataire</strong><br />
              Le Prestataire est tenu à une obligation de moyens. Sa responsabilité ne pourra être engagée que pour les dommages directs et prévisibles, à l'exclusion de tout dommage indirect.
            </p>
            <p>
              Le Prestataire ne saurait être tenu responsable :
            </p>
            <ul>
              <li>Des dysfonctionnements dus à l'hébergeur, au fournisseur d'accès ou au réseau Internet</li>
              <li>Des modifications effectuées par le Client ou un tiers après livraison</li>
              <li>De l'utilisation non conforme du site/application</li>
              <li>Du contenu fourni par le Client</li>
            </ul>
            <p>
              <strong>12.2 Force majeure</strong><br />
              Le Prestataire ne pourra être tenu responsable en cas de force majeure ou de circonstances indépendantes de sa volonté.
            </p>
          </section>

          {/* Article 13 - Confidentialité */}
          <section className="legal-section">
            <h2>Article 13 - Confidentialité</h2>
            <p>
              Les deux parties s'engagent à garder confidentielles toutes les informations échangées dans le cadre du projet, pendant et après la réalisation de celui-ci.
            </p>
            <p>
              Le Prestataire s'engage à ne pas divulguer les informations sensibles du Client (données clients, mots de passe, stratégies commerciales, etc.).
            </p>
          </section>

          {/* Article 14 - Résiliation */}
          <section className="legal-section">
            <h2>Article 14 - Résiliation et annulation</h2>
            <p>
              <strong>14.1 Résiliation par le Client</strong><br />
              Le Client peut résilier le contrat à tout moment, sous réserve de payer :
            </p>
            <ul>
              <li>Les prestations déjà réalisées</li>
              <li>Les frais déjà engagés</li>
              <li>Une indemnité de 30% du montant restant dû</li>
            </ul>
            <p>
              L'acompte versé reste acquis au Prestataire.
            </p>
            <p>
              <strong>14.2 Résiliation par le Prestataire</strong><br />
              Le Prestataire peut résilier le contrat en cas de :
            </p>
            <ul>
              <li>Non-paiement des sommes dues</li>
              <li>Non-fourniture des éléments nécessaires après relance</li>
              <li>Manquement grave du Client à ses obligations</li>
            </ul>
          </section>

          {/* Article 15 - Données personnelles */}
          <section className="legal-section">
            <h2>Article 15 - Protection des données personnelles</h2>
            <p>
              Le Prestataire s'engage à respecter la réglementation en vigueur en matière de protection des données personnelles (RGPD).
            </p>
            <p>
              Pour plus d'informations, consultez notre{' '}
              <Link to="/politique-confidentialite" className="legal-link">
                Politique de confidentialité
              </Link>.
            </p>
          </section>

          {/* Article 16 - Litiges */}
          <section className="legal-section">
            <h2>Article 16 - Litiges et droit applicable</h2>
            <p>
              <strong>16.1 Droit applicable</strong><br />
              Les présentes CGV sont soumises au droit français.
            </p>
            <p>
              <strong>16.2 Règlement amiable</strong><br />
              En cas de litige, les parties s'engagent à rechercher une solution amiable avant toute action judiciaire.
            </p>
            <p>
              <strong>16.3 Juridiction compétente</strong><br />
              À défaut d'accord amiable, les tribunaux français seront seuls compétents.
            </p>
          </section>

          {/* Article 17 - Modifications */}
          <section className="legal-section">
            <h2>Article 17 - Modification des CGV</h2>
            <p>
              Le Prestataire se réserve le droit de modifier les présentes CGV à tout moment. Les modifications s'appliquent aux nouvelles commandes et n'affectent pas les contrats en cours.
            </p>
          </section>

          {/* Contact */}
          <section className="legal-section">
            <h2>Contact</h2>
            <p>
              Pour toute question concernant ces Conditions Générales de Vente :
            </p>
            <p>
              <strong>Email :</strong> <a href="mailto:contact@dreamdev.fr">contact@dreamdev.fr</a><br />
              <strong>Téléphone :</strong> 07.66.85.46.63<br />
              <strong>Adresse :</strong> 710 Routes de Frans - Villefranche sur Saône
            </p>
          </section>

          {/* Date de mise à jour */}
          <section className="legal-section">
            <p className="legal-update">
              <strong>{t('legal.lastUpdate') || 'Dernière mise à jour'} :</strong> {new Date().toLocaleDateString('fr-FR')}
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CGV;